import {
  createBrowserRouter,
  createRoutesFromElements,
  Navigate,
  Route,
} from 'react-router-dom';

import AuthRequired from '@/modules/auth/AuthRequired';
import Layout from '@/modules/common/layout';
import {
  AddDrivers,
  Advanced,
  AppStatus,
  DriverDetails,
  DriversManagement,
  DriversPerformance,
  EditDrivers,
  Error,
  ForgotPassword,
  HelpCenter,
  Incidents,
  Login,
  Manage,
  Overview,
  Profile,
  SelectFleet,
  SetPassword,
  TextMeTheApp,
  UpdatePassword,
  ValidatorTool,
  Insurance,
} from '@/pages';
import { AnalyticsRoute } from './components/AnalyticsRoute';
import ErrorBoundary from './components/ErrorBoundary';

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route errorElement={<ErrorBoundary />}>
      <Route element={<AnalyticsRoute />}>
        <Route path="/login" element={<Login />} />
        <Route path="/set-password" element={<SetPassword />} />
        <Route path="/update-password" element={<UpdatePassword />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/text-me-the-app" element={<TextMeTheApp />} />
        <Route path="/help-center" element={<HelpCenter />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route element={<AuthRequired />}>
          <Route path="/select-fleet" element={<SelectFleet />} />
          <Route path="/" element={<Layout />}>
            <Route path="/overview" element={<Overview />} />
            <Route path="/insurance" element={<Insurance />} />
            <Route path="/incidents" element={<Incidents />} />
            <Route path="/app-status" element={<AppStatus />} />
            <Route
              path="/drivers-performance"
              element={<DriversPerformance />}
            />
            <Route path="/drivers-management" element={<DriversManagement />} />
            <Route path="/edit-drivers" element={<EditDrivers />} />
            <Route path="/driver-details" element={<DriverDetails />} />
            <Route path="/add-drivers" element={<AddDrivers />} />
            <Route path="/settings/*" />
            <Route path="/settings/profile" element={<Profile />} />
            <Route path="/settings/advanced" element={<Advanced />} />
            <Route path="/settings/manage" element={<Manage />} />
            <Route
              path="/settings/validator-tool"
              element={<ValidatorTool />}
            />
          </Route>
        </Route>
        <Route
          path="/app/settings/validator-tool"
          element={<Navigate to="/settings/validator-tool" replace />}
        />
        <Route path="*" element={<Error />} />
      </Route>
    </Route>
  )
);

export default router;
